// src/pages/Landing.jsx
import Navbar from '../components/forum/Navbar';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import About from '../components/landing/About';
import Footer from '../components/landing/Footer';
import React, { useEffect } from 'react';
import { preloadImage } from '../hooks/useEffect';

const Landing = () => {
  return (
    <div className="bg-dark min-h-screen text-white">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Footer />
    </div>
  );
  useEffect(() => {
    const loginBgImage = '/src/assets/images/pexels-adrien-olichon-1257089-2387793.jpg';
    const signupImage = '/src/assets/images/pexels-bemistermister-4034475.jpg';

    preloadImage(loginBgImage);
    preloadImage(signupImage);
  }, []);
};

export default Landing;
